import React, { Component } from "react";
import styles from "./deviceLabelModal.module.less"
import { DarkModal } from "@/components/Modal";
import { downloadImg } from '@/utils/constant'
import http from "@/http"
import DevicePlanePosition, { DeviceInfo } from "./DevicePlanePosition";

const HttpDevice = http.tokiot.device;
class DeviceLabelModal extends Component {
    state = {
        deviceKey: 0,
    }
    componentDidMount() {
    }

    onModalCancel = () => {
        const { onClose } = this.props;
        onClose && onClose();
    }


    render() {
        const { devices } = this.state;
        const { visible, deviceLabelInfo } = this.props;
        const planePosition = deviceLabelInfo.planePosition;
        let device = deviceLabelInfo.deviceInfo;
        let picture = deviceLabelInfo.picture;
        let deviceList = [new DeviceInfo(device, planePosition)];
        let imageUrl = downloadImg + picture.image;
        if (device)
            device.params = JSON.parse(device.lastAlarmParams)

        let showParams = () => {
            return (
                <div className={styles.info}>
                    <div className={styles.left}>
                        {device.params.map((item, index) => { return (<div className={styles.name} >{`${item.name} :`}</div>) })}
                    </div>
                    <div className={styles.right}>
                        {device.params.map((item, index) => { return (<div className={styles.value} >{` ${item.value}`}</div>) })}
                    </div>
                </div>
            )
        }
        return (
            <DarkModal
                title={`平面图`}
                centered
                width={`15rem`}
                visible={visible}
                onCancel={this.onModalCancel}
                footer={null}
            >
                <div className={styles.main}>
                    {device ?
                        <div className={styles.deviceInfo}>
                            <div className={styles.title}>
                                设备详情
                            </div >
                            <div className={styles.row}>
                                <div className={styles.left}>
                                    <img className={styles.image} src={downloadImg + device.productImage1} alt='' />
                                </div >
                                <div className={styles.right}>
                                    <div className={styles.value}>{device.name}</div >
                                    <div className={styles.value}>{device.productName}</div >
                                </div >
                            </div >
                            <div className={styles.row}>
                                <div className={styles.name}>{`设备编号：`}</div >
                                <div className={styles.value}>{device.sn}</div >
                            </div >
                            <div className={styles.row}>
                                <div className={styles.name}>{`设备位置：`}</div >
                                <div className={styles.value}>{device.address}</div >
                            </div >
                            <div className={styles.row}>
                                <div className={styles.name}>{`安装地址：`}</div >
                                <div className={styles.value}>{device.sn}</div >
                            </div >
                            <div className={styles.row}>
                                <div className={styles.name}>{`告警名称：`}</div >
                                <div className={styles.value}>{device.lastAlarmName}</div >
                            </div >
                            {device.params && device.params.length > 0 ?
                                <div className={styles.row}>
                                    <div className={styles.right}>
                                        <div className={styles.value}>{`告警参数：`}</div >
                                        <div className={styles.value}>{showParams()}</div >
                                    </div >
                                </div >
                                : ""}
                        </div > : ''}
                    <div className={styles.deviceLabel}>
                        <div className={styles.title}>
                            平面图
                        </div >
                        <div className={styles.body}>
                            <DevicePlanePosition
                                deviceList={deviceList}
                                imageUrl={imageUrl}
                            />
                        </div >
                    </div >
                </div >
            </DarkModal >
        )
    }
}
export default DeviceLabelModal
